// import { useNavigate } from "react-router-dom";
// import { useState } from "react";
// import axios from "axios";
// import { GoogleLogin } from "@react-oauth/google";
// // import { jwtDecode } from "jwt-decode"; 

// function Login() {
//   const navigate = useNavigate();
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");

//   const handleLogin = async (e) => {
//     e.preventDefault();

//     try {
//       const res = await axios.post(`${process.env.REACT_APP_API_URL}/login`, {
//         email,
//         password,
//       });
//       localStorage.setItem("user", JSON.stringify(res.data.user));
//       navigate("/post");
//     } catch (err) {
//       alert("❌ Invalid email or password");
//     }
//   };

//   // const handleGoogleSuccess = (credentialResponse) => {
//   //   const decoded = jwtDecode(credentialResponse.credential);
//   //   localStorage.setItem(
//   //     "user",
//   //     JSON.stringify({
//   //       email: decoded.email,
//   //       name: decoded.name,
//   //     })
//   //   );
//   //   navigate("/post");
//   // };

//   const handleGoogleSuccess = async (credentialResponse) => {
//   try {
//     const res = await axios.post(
//       `${process.env.REACT_APP_API_URL}/auth/google`,
//       {
//         credential: credentialResponse.credential,
//       }
//     );

//     localStorage.setItem("user", JSON.stringify(res.data.user));
//     navigate("/post");
//   } catch (err) {
//     console.error(err);
//     alert("❌ Google login failed");
//   }
// };

//   const handleGoogleFailure = () => {
//     alert("❌ Google login failed");
//   };

//   return (
//     <div className="login d-flex justify-content-center bg-light py-5">
//       <div className="card login-card shadow p-4">
//         <h4 className="text-center mb-3">Login</h4>
//         <form onSubmit={handleLogin}>
//           <div className="mb-3">
//             <label className="form-label">Email</label>
//             <input
//               type="email"
//               className="form-control"
//               placeholder="Enter email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//             />
//           </div>

//           <div className="mb-3">
//             <label className="form-label">Password</label>
//             <input
//               type="password"
//               className="form-control"
//               placeholder="Enter password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               required
//             />
//           </div>

//           <div className="d-flex justify-content-center">
//             <button type="submit" className="btn btn-secondary w-100">
//               Login
//             </button>
//           </div>
//         </form>

//         <div className="text-center my-3">or</div>

//         <div className="google-login-btn">
//           <GoogleLogin
//             onSuccess={handleGoogleSuccess}
//             onError={handleGoogleFailure}
//           />
//         </div>

//         <div className="text-center mt-3 small-text">
//           <p className="mb-1">
//             Don’t have an account yet?{" "}
//             <a href="/signup" className="text-decoration-none">
//               Signup
//             </a>
//           </p>
//           <p className="mb-0">
//             Forgot your password?{" "}
//             <a href="/reset" className="text-decoration-none">
//               Reset
//             </a>
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Login;



import { useNavigate } from "react-router-dom"; 
import { useState } from "react";
import axios from "axios";
import { GoogleLogin } from "@react-oauth/google";
import { useAuth } from "../AuthContext"; // ✅ import AuthContext

function Login() {
  const navigate = useNavigate();
  const { login } = useAuth(); // ✅ get login function from context
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/login`, {
        email,
        password,
      });

      login(res.data.user); // ✅ use context instead of localStorage
      navigate("/post");    // redirect after login
    } catch (err) {
      alert("❌ Invalid email or password");
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/google`,
        {
          credential: credentialResponse.credential,
        }
      );

      login(res.data.user); // ✅ use context instead of localStorage
      navigate("/post");    // redirect after Google login
    } catch (err) {
      console.error(err);
      alert("❌ Google login failed");
    }
  };

  const handleGoogleFailure = () => {
    alert("❌ Google login failed");
  };

  return (
    <div className="login d-flex justify-content-center bg-light py-5">
      <div className="card login-card shadow p-4">
        <h4 className="text-center mb-3">Login</h4>
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="d-flex justify-content-center">
            <button type="submit" className="btn btn-secondary w-100">
              Login
            </button>
          </div>
        </form>

        <div className="text-center my-3">or</div>

        <div className="google-login-btn">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleFailure}
          />
        </div>

        <div className="text-center mt-3 small-text">
          <p className="mb-1">
            Don’t have an account yet?{" "}
            <a href="/signup" className="text-decoration-none">
              Signup
            </a>
          </p>
          <p className="mb-0">
            Forgot your password?{" "}
            <a href="/reset" className="text-decoration-none">
              Reset
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;